import { render, staticRenderFns } from "./ProductEditStock.vue?vue&type=template&id=49562c88"
import script from "./ProductEditStock.vue?vue&type=script&lang=ts"
export * from "./ProductEditStock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49562c88')) {
      api.createRecord('49562c88', component.options)
    } else {
      api.reload('49562c88', component.options)
    }
    module.hot.accept("./ProductEditStock.vue?vue&type=template&id=49562c88", function () {
      api.rerender('49562c88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductEditStock.vue"
export default component.exports